import * as React from 'react'
import { NavigationDropdown } from '../NavigationDropdown'
import { autoUpdate, offset, shift, useFloating } from '@floating-ui/react-dom'
import { NavigationLink } from '../../UI/NavigationLink'
import CustomLink from '../../CustomLink'
import { NavigationItemProps } from './interfaces'
import { StyledDropdownBoxWrapper, StyledDropdownWrapper, StyledWrapper } from './styled'
import { isExternalLink } from '../../../lib/utils'

export const NavigationItem = ({ label, to, $inverted, dropdown, onMouseEnter, onMouseLeave, $bordered }: NavigationItemProps) => {
  const { x, y, floating, reference } = useFloating({
    whileElementsMounted: autoUpdate,
    placement: 'bottom-start',
    middleware: [
      shift({
        elementContext: 'reference',
      }),
      offset({ crossAxis: -50 }),
    ],
  })

  const isLink = !(!!dropdown && !!dropdown[0])

  return (
    <StyledWrapper ref={reference} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} $inverted={$inverted}
    >
      <NavigationLink
        data={`isLink? ${isLink}`}
        as={isLink ? CustomLink : 'div'}
        target={isExternalLink(to) ? '_blank' : undefined}
        {...(isLink && { to })}
        $inverted={$inverted}
        $bordered={$bordered}
      >
        {label}
      </NavigationLink>
      {!!dropdown && !!dropdown[0] && (
        <StyledDropdownWrapper ref={floating} {...(x && y && { style: { left: `${x}px`, top: `${y}px` } })}>
          <StyledDropdownBoxWrapper>
            <NavigationDropdown.Dropdown data={dropdown[0]} />
          </StyledDropdownBoxWrapper>
        </StyledDropdownWrapper>
      )}
    </StyledWrapper>
  )
}

export default NavigationItem
